<script setup>
const BAR_HEIGHTS = [40, 65, 45, 80, 55, 70, 35, 60, 50, 75, 45, 65];
</script>

<template>
  <div
    class="flex items-end justify-between gap-2 w-full h-72 px-2"
    role="status"
    :aria-label="$t('REPORT.LOADING_CHART')"
  >
    <div
      v-for="(height, index) in BAR_HEIGHTS"
      :key="index"
      class="flex-1 rounded-t bg-n-slate-3 animate-pulse"
      :style="{ height: `${height}%` }"
    />
  </div>
</template>
